import useCredentials from '../../../Hooks/useCredentials';
import useGlobals from '../../../Hooks/useGlobals';
import AdminBox from '../../Utility/AdminBox';
import AdminContainer from '../../Utility/AdminContainer';
import AdminViewContent from '../../Utility/AdminViewContent';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import LoadingSpinner from '../../Utility/LoadingSpinner';
import { Credential } from '../../../Types';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { PaginationWrapper } from '../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../Types/PaginationParams';
import { credentialsService } from '../../../Services/credentialsService';
import useSearchFilter from '../../../Hooks/useSearchFilter';
import SearchFilter from '../../Utility/SearchFilter';

function Credentials() {
    const { i18n, handleNavigate, windowWidth, getBreakpoint } = useGlobals();
    const { CredentialsActions } = useCredentials();
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <SearchFilter
                        value={localQuery}
                        onChange={searchActions.setLocalQuery}
                        onApply={searchActions.applyQuery}
                        onClear={searchActions.clearQuery}
                    />
                    <div className="hidden md:block">
                        <AdminViewHeader
                            gridCols={GRID_COLS}
                            cols={{
                                cols: [
                                    {
                                        text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                                    },
                                ],
                                button: {
                                    text: i18n.translate({ id: 'newCredential.button', sourceName: 'Credentials' }),
                                    function: () => handleNavigate('new'),
                                },
                            }}
                        />

                        <hr className="border-layout-borderColor mt-5" />
                    </div>

                    <div className="mb-4 block md:hidden">
                        <Button
                            className="!m-0 !mb-3 flex justify-center items-center w-full"
                            onClick={() => handleNavigate('new')}
                        >
                            {i18n.translate({ id: 'newCredential.button', sourceName: 'Credentials' })}
                        </Button>
                    </div>

                    <PaginationWrapper
                        listType={PaginationListType.Credentials}
                        itemsFunction={credentialsService.getCredentialsByPage}
                        itemsPerPage={15}
                        query={query ?? null}
                        renderItem={(credential: Credential, index: number) => (
                            <AdminViewContent
                                key={credential.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={credential.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: credential.name ?? '',
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(credential.identifier),
                                                icon: <PencilSimple />,
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () =>
                                                    CredentialsActions.handleOpenConfirmDialog(credential.identifier),
                                                icon: <Trash />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    />
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Credentials;
